<ng-container *ngIf="pricingStatus === PricingStatusEnum.loading">
    <svg class="loading-svg-icon" viewBox="0 0 28 28">
        <path fill="#eee"
              d="M14,27C6.83,27,1,21.17,1,14S6.83,1,14,1c7.17,0,13,5.83,13,13S21.17,27,14,27z M14,3C7.93,3,3,7.93,3,14 s4.93,11,11,11s11-4.93,11-11S20.07,3,14,3z"/>
        <path [attr.fill]="getBrandColor()" d="M14,1v2c6.07,0,11,4.93,11,11s-4.93,11-11,11v2c7.17,0,13-5.83,13-13S21.17,1,14,1z">
            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 14 14" to="360 14 14"
                              dur="1s" repeatCount="indefinite"/>
        </path>
    </svg>
</ng-container>

<div class="price-container" *ngIf="pricingStatus === PricingStatusEnum.done">
    <div class="price-label" [ngClass]="classesPriceLabel" *ngIf="getCurrency() != ''">
        Price ({{getCurrency()}})
    </div>
    <div class="price-lane">
        <span class="price-value">{{ getFinalPrice() }}</span>
    </div>
    <div *ngIf="isSpecialOffer()" class="price-special-offer-label">Special offer</div>
    <span *ngIf="isOnlinePriceBest()" class="price-right-text ml">Online exclusive</span>
    <div class="under-price">
        <span *ngIf="getPromoEndDate() != ''" class="price-right-text">
            <span class="bold">Ends:</span>
            {{getPromoEndDate()}}
        </span>
        <span class="gray crossed-out">
            {{getSecondBestPrice()}}
        </span>
        <span *ngIf="getSavings() != ''" class="price-right-text save-color">{{getSavings()}}</span>
    </div>
</div>

<ng-template #loginContent>
    <span>
        <a class="tf-log-in" style="cursor:pointer;" (click)="signIn()">Sign in</a> now to see<br> your best price
    </span>
</ng-template>

<ng-template #bestPriceContent>
    <span>
        {{getBestPricePopoverContent()}}
    </span>
</ng-template>
